<template>
    <div>
      <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" v-on:closeSidebar="updateAsignacionAsesoresIndex" />
      <feather-icon title="Ver Perfil Cliente" icon="UserIcon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="goToPerfilInternoCliente(params.data)" />
      <feather-icon title="Cambiar Asesor" icon="ShieldIcon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="editAssignedAdvisor(params.data)" />
    </div>
</template>

<script>
import EditAssignedAdvisorViewSidebar from './../EditAssignedAdvisorViewSidebar.vue'
export default {
  components: {
    DataViewSidebar: EditAssignedAdvisorViewSidebar
  },
  data () {
    return {
      // Data Sidebar Edit Assigned Advisor
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  name: 'CellRendererActions',
  methods: {
    goToPerfilInternoCliente (data) {
      this.$router.push({name: 'admin.cliente', params: {client_id: data.id_client}})
    },
    updateAsignacionAsesoresIndex () {
      this.$vs.loading()
      setTimeout(function () { this.refrescarAsignacionAsesoresIndex() }.bind(this), 0)
    },
    refrescarAsignacionAsesoresIndex () {
      this.$store.dispatch('fetchAssignedAdvisors')
        .then(() => { this.$vs.loading.close() })
    },
    editAssignedAdvisor (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    }
  }
}
</script>
